import React, { useEffect, useState } from 'react'
import { deleteItem, loadLanguages,  } from '../../utils/Network';
import { useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { isAdmin, sortLanguages, userAvatar } from '../../utils';
import Gallery from '../Gallery';
import Navbar from '../../components/Navbar';
import Mainmenu from '../../components/Mainmenu';
import Footer from '../../components/Footer';
import SelectPublished from '../../components/select/SelectPublished';
import { ApiHttpService } from '../../utils/http/api';
import SelectCourseParticipantModal from '../../components/contest/SelectCourseParticipantModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Modal from 'react-modal';
import HistoryGalleryForm from '../../components/forms/HistoryGalleryForm';
import PollReportBarChart from '../../components/charts/PollReportBarChart';
import SelectCourses from '../../components/SelectCourses';


export default function Poll() {

    const [poll, setPoll] = useState(null);
    const [poll_items, setPollItems] = useState(null);
    const [poll_results, setPollResults] = useState(null);
    
    const [exclude_ids, setExcludeIds] = useState([]);
    
    
    const [names, setNames] = useState(null);
    const [published, setPublished] = useState(null);
    const [course, setCourse] = useState(null);
    const [languages, setLanguages] = useState(null);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [courseparticipant_modal_is_open, setCourseParticipantModalIsOpen] = useState(false);
    
    const [top_ten_mode, setTopTenMode] = useState(false);
    
    const [show_delete, setShowDelete] = useState(false);
    const [show_draggable, setShowDraggable] = useState(false);

    const params = useParams()
    var id= params.id

    const [image, setImage] = useState(null);
    

    const [error, setError] = useState(null);
    const [done, setDone] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageloading, setPageLoading] = useState(false);

    useEffect(() => {
        setPageLoading(true)
        loadLanguages().then(languages => {

            //languages=languages.filter(x=> x.language !==16)
            setLanguages(sortLanguages(languages));
            setPageLoading(false)
        });


        if (id) {
            setPageLoading(true)
            ApiHttpService.loadPoll(id).then(poll => {
                setPoll(poll)
                setNames(poll.names)
                setPublished(poll.published)
                setCourse(poll.course)
                setImage(poll.image)
                
            })

            _getPollItems();
            _getPollResults();
        }
    }, [])
    
  


    const _getPollItems = () => {
      ApiHttpService.loadPollItems(id,1).then(data => {
         if(data.results)
           setPollItems(data.results)
      })
    }

    const _getPollResults = () => {
      ApiHttpService.loadPollResults(id).then(data => {
           setPollResults(data)
      })
    }

    function polliItemResult(poll_item){
      // const sum = agent.reviews.reduce(function(a, b) { return a. local_knowledge_rating + b. local_knowledge_rating; }, 0)
    
      if(!poll_results) return null;


      const vote = poll_results.filter(item=>item.pollitem.id==poll_item.id)[0].vote;

      return (
        <p>{vote.toLocaleString('en-US')}</p>
      )
    } 

    function pollResultSum(){
      if(!poll_results) return null;
      
      var sum = 0;
      poll_results.forEach(item=>sum+=item.vote)

      return (
        <>{sum.toLocaleString('en-US')}</>
      )
    }

    
    const handleNamesOnChange = (e , field="name") => {
        //alert(e.target.value)
        var language_id = e.target.getAttribute("language_id")

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...names];

            let name_el = temp_names.find(x => x.language === parseInt(language_id))

            switch(field){
              default : // "name"
                name_el.name = e.target.value;
              break;
            }
            setNames(temp_names)
        }
        else {

            var new_name = {}

            switch(field){
              default : // "name"
               new_name = { name: e.target.value, description: "", language: parseInt(language_id) }
              break;
            }

            var temp_names_array = [];
            if (names)
            temp_names_array = [...names, new_name];
            else temp_names_array = [new_name]
            setNames(temp_names_array)
        }
    }

    const handleDescriptionChange = (language_id, data,field="description") => {
        //alert(e.target.value)

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...names];

            let name_el = temp_names.find(x => x.language === parseInt(language_id))
            switch(field){
              default : // "name"
                name_el.description = data;
              break;
            }

            setNames(temp_names)
        }
        else if (!id) {

          var new_name

          switch(field){
            default : 
              new_name = { name: "", description: data, language: parseInt(language_id) }
            break;
          }

            var temp_namesa = [];
            if (names)
                temp_namesa = [...names, new_name];
            else temp_namesa = [new_name]
            setNames(temp_namesa)
        }
    }

    const saveChanges = () => {

        setError(null);
        setLoading(true);
        setDone(null)

        if (!names || names[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }

      
        var body = {
            names: names,
            published: published,
            course: course,
            image: image,
          }

        
        if(id) body["id"] = id


        ApiHttpService.savePoll(body).then(function (data) {
          setLoading(false);
          setDone("Changes saved successfully")
          if (data.image) setImage(data.image);
        });
    }

    const setSelectedImageGallery = (gallery_item) => {
      setImage(gallery_item?.image)
    }


    const openGallery = () => {

        setGalleryModalIsOpen(true)

    }

    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    const closeCourseParticipantModal = () => {
        setCourseParticipantModalIsOpen(false)
    }


    const addSelectedUserTalentId = (usertalent)=>{
      var body = { 
        poll : id,
        usertalent : usertalent,
      }

      setLoading(true)
      ApiHttpService.savePollItem(body).then(data => {
        // console.log(data)
        _getPollItems()
        setLoading(false)
    })
      
    }


    const _delete = (id,type) => {
      
      if(window.confirm('Are you sure you wish to delete this item?')){
        switch(type){
          case "pollitem":
            deleteItem(`api/pollitem`,id).then((res)=>{ 
              setPollItems(poll_items.filter(item=>item.id!=id))
            })
            break;
          default: return
        }
      }

      
  }

 

  const onTopTenTalentDragEnd = result => {
    const { destination, source, draggableId } = result;

      if (!destination) return;
      if (
          destination.draggableId === source.draggableId &&
          destination.index === source.index
      )
          return;

      var talent = poll_items.find(x => x.id == draggableId)
      var temp = poll_items;

      temp.splice(source.index, 1)
      temp.splice(destination.index, 0, talent)

      var ids = [];
      temp.forEach(child => {
          ids.push(child.id)
      })

      ApiHttpService.saveSortOrder(`api/pollitem/setsortorder/`,ids).then(data => {
          console.log(data)
      })

      setPollItems(temp)
  }


    return (
    <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <Gallery
          setSelectedGalleryItem={setSelectedImageGallery}
          isOpen={gallery_modal_is_open}
          key={"gmo"+gallery_modal_is_open}
          closeGallery={() => {
            closeGallery();
          }}
        />
        <SelectCourseParticipantModal
          course="20"
          isOpen={courseparticipant_modal_is_open}
          key={"cpm"+courseparticipant_modal_is_open}
          exlclude_usertalents={exclude_ids}
          setSelectedItem={(item)=>{
            if(item && item.usertalent){
              addSelectedUserTalentId(item.usertalent.id)
            }
            setCourseParticipantModalIsOpen(false)
          }}
          onClose={() => {
            closeCourseParticipantModal();
          }}
        />

        
        
        <div className="content-wrapper">
          <section className="content-header">
            <h3 className="box-title mt-5"></h3>
            <ol className="breadcrumb">
              <li>
                <a href="dashboard">
                  <i className="fa fa-dashboard"></i> Home
                </a>
              </li>
              <li>
                <a href="polls">Polls</a>
              </li>
              <li className="active">View</li>
            </ol>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-md-12 col-xl-12">
                <div className="box box-primary bg-ddd">
                  <div className="box-header no-border">
                    <h3 className="box-title">
                      {id && "Edit "} {!id && "Add New "} Vote
                    </h3>
                  </div>
                  <div className="box-body ">
                    <div className=" ">
                      {pageloading && (
                        <>
                          <div className="overlay">
                            <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                          </div>
                        </>
                      )}

                      <form className="form-horizontal">
                        <div>
                          <div className="col-md-7 col-lg-8 col-xl-10">
                            <div className="nav-tabs-custom">
                              <ul className="nav nav-tabs">
                                {languages &&
                                  languages.map((language, i) => (
                                    <li
                                      key={language.id}
                                      className={
                                        language.is_default ? "active" : ""
                                      }
                                    >
                                      <a
                                        href={`#tab${language.id}`}
                                        data-toggle="tab"
                                        className="kfont"
                                      >
                                        {language.name}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                              <div className="tab-content">
                                {languages &&
                                  languages.map((language, i) => (
                                    <div
                                      key={i}
                                      className={
                                        language.is_default
                                          ? "tab-pane active"
                                          : "tab-pane "
                                      }
                                      id={`tab${language.id}`}
                                    >
                                      <div className="form-row">
                                        <input
                                          type="text"
                                          name="name"
                                          className="form-control mb-10 mxw-200"
                                          language_id={language.id}
                                          value={
                                            names &&
                                            names.find(
                                              (x) => x.language === language.id
                                            )
                                              ? names.find(
                                                  (x) =>
                                                    x.language === language.id
                                                ).name
                                              : ""
                                          }
                                          onChange={handleNamesOnChange}
                                          placeholder={language.name}
                                        />
                                      </div>

                                      <div className="form-row">
                                        <label className=""></label>
                                        <div className="">
                                          <CKEditor
                                            editor={ClassicEditor}
                                            data={
                                              names &&
                                              names.find(
                                                (x) =>
                                                  x.language === language.id
                                              )
                                                ? names.find(
                                                    (x) =>
                                                      x.language === language.id
                                                  ).description
                                                  ? names.find(
                                                      (x) =>
                                                        x.language ===
                                                        language.id
                                                    ).description
                                                  : ""
                                                : ""
                                            }
                                            onReady={(editor) => {
                                              // You can store the "editor" and use when it is needed.
                                            }}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              handleDescriptionChange(
                                                language.id,
                                                data,
                                                "description"
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-5 pt-10 col-lg-4 col-xl-2">
                           
                            <div className="form-group mx-0">
                                <SelectPublished
                                 key={published+"pb"}
                                 value={published}
                                 width={"100%"}
                                 callback={(value)=>{ setPublished(value) }} />
                            </div> 
                            <div className="form-group mx-0">
                                <SelectCourses
                                 key={course}
                                 value={course}
                                 width={"100%"}
                                 callback={(value)=>{ setCourse(value) }} />
                            </div> 
                            <hr />
                            

                            <div className="form-group mx-0">
                              <img
                                className="img upload-img mb-5"
                                onClick={openGallery}
                                alt=""
                                src={
                                  image
                                    ? image
                                    : "images/default.png"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="box-footer">
                    {id && (
                      <>
                        <a href="coursehistories" className="btn btn-default">
                          Cancel
                        </a>
                      </>
                    )}

                      {isAdmin() && 
                    <button
                      type="button"
                      onClick={saveChanges}
                      disabled={loading}
                      className="btn btn-primary pull-right"
                    >
                      Save Changes
                    </button>
                  }
                  </div>
                </div>
                <div className="box box-primary bg-ddd  ">
                  <div className="box-header no-border">
                    <h3 className="box-title mt-5">
                      Votes
                    </h3>
                    <a href="#open" onClick={(e) => { 
                        e.preventDefault();
                        var ids = poll_items.map(item=>item.usertalent.id)
                        setExcludeIds(ids)
                        setTopTenMode(1)
                        setCourseParticipantModalIsOpen(true)
                        }} title="Add New" className="btn btn-primary pull-right ml-10 "><i className="fa fa-user-plus"></i></a>
                        <a href="#show_delete"  onClick={(e)=>{ e.preventDefault(); setShowDraggable(true);  setShowDelete(!show_delete) }} className="btn btn-default pull-right ml-10 "><i className="fa fa-trash"></i></a>
                        <a href="#show_draggable" title='Make poll items draggable'  onClick={(e)=>{ e.preventDefault(); setShowDraggable(!show_draggable) }} className="btn btn-default pull-right ml-10 "><i className="fa fa-arrows"></i></a>

                  </div>
                  <div className="box-body">
                    <div className="col-md-12 ">
                        <div className="row">
                          <div className="col-md-12">
                            {show_draggable && <DragDropContext
                                    onDragEnd={onTopTenTalentDragEnd}
                              >
                                <Droppable droppableId={'pollitem_droppable'}>
                                  {(drop_provided,snapshot) => (
                                    <div className="padding-10 flex justify-content-center flex-direction-row "
                                    style={{ backgroundColor: snapshot.isDraggingOver ? '#edeac7' : '' }}
                                      ref={drop_provided.innerRef}
                                      {...drop_provided.dropableProps}>
                                        {poll_items?.map((item, i) => (
                                          <Draggable
                                            key={`pollitem${item.id}`}
                                            draggableId={`${item.id}`}
                                            index={i}
                                          >
                                            {(provided) => (
                                              <div  
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef}
                                                        className=" mr-5 mb-5 circles-container">
                                                  <a href={`usertalent/${item.usertalent.user?.profile?.id}`}>
                                                    <img src={item.usertalent.user?.profile.image}  alt="" className="img-circle img-fluid mb-3 width-200" />
                                                  </a>
                                                  <b className='mb-5'>{item.usertalent.user?.profile?.first_name}</b>
                                                  {show_delete && (
                                                    <a href="#delete" onClick={(e)=>{  e.preventDefault(); _delete(item.id,"pollitem") }} className="btn btn-danger btn-sm pull-right mb-10 ">
                                                      <i className="fa fa-trash"></i>
                                                    </a>
                                                  )}
                                              </div>
                                            )}
                                          </Draggable>

                                        )
                                        )}
                                      <div className="clear"></div>
                                  </div>
                                )}
                                </Droppable>
                              </DragDropContext>}
                              {!show_draggable && 
                              <>
                              <h4 className="text-center">Total Votes : {pollResultSum()}</h4>
                              <hr />
                              <div className="poll-items-result-container">
                                {poll_items?.map((item, i) => (
                                    <div  
                                    key={"poll_item_k_"+item.id}
                                              className=" mr-5 mb-5 circles-container">
                                        <a href={`usertalent/${item.usertalent.user?.profile?.id}`}>
                                          <img src={item.usertalent.user?.profile.image}  alt="" className="img-circle img-fluid mb-3 mr-5 width-200" />
                                        </a>
                                        <b className='mb-5'>{item.usertalent.user?.profile?.first_name}</b>
                                        <b className='mb-5'>{polliItemResult(item)}</b>
                                        
                                    </div>
                                  ))
                                }
                              </div>
                              </>
                              }
                          </div>
                      </div>
                    </div>
                  </div>
                </div>

                  {error && (
                    <>
                      <div className="alert alert-danger">{error}</div>
                    </>
                  )}

                  {done &&
                      <div className="alert alert-success  mt-5">
                          {done}
                      </div>
                  }

                  {loading && (
                    <>
                      <div className="alert alert-info">please wait...</div>
                    </>
                  )}

                  {/* <div className="box box-primary bg-ddd ">
                    <div className="box-header with-border">
                      <h3 className="box-title mt-5">
                      Poll Results
                      </h3>

                    </div>
                    <div className="box-body">
                          <div className="row">
                            <div className="col-md-12">
                                <PollReportBarChart key={poll_results} poll_results={poll_results} />
                            </div>
                        </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );

}
